import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ShowItem from '../ShowItem';
import { Alert, Button, Modal, Spinner } from 'react-bootstrap';
import Icon from '../Icon';
import { useLazyGetArtifactoryQuery, useLazyGetGitlabQuery } from '../../api/repoTesterApiSlice';

const TestShow = (props) => {
  if (props.isLoading) {
    return (
      <ShowItem label={props.title}><Spinner animation="border" variant="primary" /></ShowItem>
    )
  }
  if (props.isSuccess) {
    return (
      <ShowItem label={props.title}><Icon icon='checkCircle'/></ShowItem>
    )
  }
  if (props.isError) {
    return (
      <ShowItem label={props.title}>
        <Alert variant='danger'>
          {props.error.data.error}
        </Alert>
      </ShowItem>
    )
  }
}

export const CredentialTesterButton = ({slug}) => {
	const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);
  const [getGitlab, resultGitlab] = useLazyGetGitlabQuery()
  const [getArtifactory, resultArtifactory] = useLazyGetArtifactoryQuery()
  const runTest = () => {
    setShow(true)
    getGitlab(slug)
    getArtifactory(slug)
  }

  return (
    <>
      <Button onClick={runTest}>
        <Icon icon='play' text={t("publisher.credentialTester.iconText")} />
      </Button>
      <Modal show={show} onHide={()=>{setShow(false)}}>
        <Modal.Header closeButton>
          <Modal.Title>{t("publisher.credentialTester.title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TestShow title='Gitlab' {...resultGitlab} />
          <TestShow title='Artifactory' {...resultArtifactory} />
        </Modal.Body>
      </Modal>
    </>
  )
}
